import React from "react";
import PropTypes from "prop-types";
import TypewriterAnimation from "@default/general-components/typewriter-animation";
import iconLinksBlack from "../../../assets/ui/icon-links-black.svg?url";

const SocialLinks = ({ content }) => {
  if (
    content.fieldYoutube ||
    content.fieldFacebook ||
    content.fieldInstagram ||
    content.fieldX ||
    content.fieldSoundcloud ||
    content.fieldWebsite ||
    content.fieldVimeo ||
    content.fieldLinkedin
  ) {
    return (
      <div className="social-wrapper">
        {(content.fieldYoutube ||
          content.fieldFacebook ||
          content.fieldInstagram ||
          content.fieldX ||
          content.fieldSoundcloud ||
          content.fieldWebsite ||
          content.fieldVimeo ||
          content.fieldLinkedin) && (
          <div className="social-links">
            <div className="icon-wrapper">
              <img src={iconLinksBlack} className="icon links" alt="Links" />
            </div>
            <div className="link-wrapper">
              {content.fieldWebsite && content.fieldWebsite.uri && (
                <a
                  className={"link website action-element"}
                  href={content.fieldWebsite.uri.path}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <TypewriterAnimation>
                    {content.fieldWebsite.uri.path
                      .replace("https://", "")
                      .replace("http://", "")}
                  </TypewriterAnimation>
                </a>
              )}
              {content.fieldLinkedin && content.fieldLinkedin.uri && (
                <a
                  className={"link linkedin action-element"}
                  href={content.fieldLinkedin.uri.path}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <TypewriterAnimation>LinkedIn</TypewriterAnimation>
                </a>
              )}
              {content.fieldInstagram && content.fieldInstagram.uri && (
                <a
                  className={"link facebook action-element"}
                  href={content.fieldInstagram.uri.path}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <TypewriterAnimation>Instagram</TypewriterAnimation>
                </a>
              )}
              {content.fieldTiktok && content.fieldTiktok.uri && (
                <a
                  className={"link tiktok action-element"}
                  href={content.fieldTiktok.uri.path}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <TypewriterAnimation>TikTok</TypewriterAnimation>
                </a>
              )}
              {content.fieldFacebook && content.fieldFacebook.uri && (
                <a
                  className={"link facebook action-element"}
                  href={content.fieldFacebook.uri.path}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <TypewriterAnimation>Facebook</TypewriterAnimation>
                </a>
              )}
              {content.fieldX && content.fieldX.uri && (
                <a
                  className={"link twitter x action-element"}
                  href={content.fieldX.uri.path}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <TypewriterAnimation>X</TypewriterAnimation>
                </a>
              )}
              {content.fieldSoundcloud && content.fieldSoundcloud.uri && (
                <a
                  className={"link soundcloud action-element"}
                  href={content.fieldSoundcloud.uri.path}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <TypewriterAnimation>Soundcloud</TypewriterAnimation>
                </a>
              )}
              {content.fieldYoutube && content.fieldYoutube.uri && (
                <a
                  className={"link youtube action-element"}
                  href={content.fieldYoutube.uri.path}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <TypewriterAnimation>YouTube</TypewriterAnimation>
                </a>
              )}
              {content.fieldVimeo && content.fieldVimeo.uri && (
                <a
                  className={"link vimeo action-element"}
                  href={content.fieldVimeo.uri.path}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <TypewriterAnimation>Vimeo</TypewriterAnimation>
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

SocialLinks.propTypes = {
  content: PropTypes.object.isRequired,
};

export default SocialLinks;
